<div class="row">
    <div class="col-md-6 col-xl-3">
        <div class="card p-3 mb-5">
            <div class="align-box-row">
                <div class="text-first font-size-xl font-weight-bold pr-2">55%</div>
                <div class="flex-grow-1">
                    <progressbar [animate]="true" [value]="55"
                                 class="progress-bar-rounded progress-sm"
                                 type="first">
                    </progressbar>
                </div>
            </div>
            <div class="text-black-50 pt-2">
                Expenses target
            </div>
        </div>
    </div>
    <div class="col-md-6 col-xl-3">
        <div class="card p-3 mb-5">
            <div class="align-box-row">
                <div class="text-success font-size-xl font-weight-bold pr-2">76%</div>
                <div class="flex-grow-1">
                    <progressbar [animate]="true" [value]="76"
                                 class="progress-bar-rounded progress-sm"
                                 type="success">
                    </progressbar>
                </div>
            </div>
            <div class="text-black-50 pt-2">
                Sales target
            </div>
        </div>
    </div>
    <div class="col-md-6 col-xl-3">
        <div class="card p-3 mb-5 bg-asteroid">
            <div class="align-box-row">
                <div class="text-danger font-size-xl font-weight-bold pr-2">61%</div>
                <div class="flex-grow-1">
                    <progressbar [animate]="true" [value]="61"
                                 class="progress-bar-rounded bg-white-50 progress-sm"
                                 type="danger">
                    </progressbar>
                </div>
            </div>
            <div class="text-white-50 pt-2">
                Income target
            </div>
        </div>
    </div>
    <div class="col-md-6 col-xl-3">
        <div class="card p-3 mb-5 bg-midnight-bloom">
            <div class="align-box-row">
                <div class="text-warning font-size-xl font-weight-bold pr-2">83%</div>
                <div class="flex-grow-1">
                    <progressbar [animate]="true" [value]="83"
                                 class="progress-bar-rounded bg-white-50 progress-sm"
                                 type="warning">
                    </progressbar>
                </div>
            </div>
            <div class="text-white-50 pt-2">
                Spendings target
            </div>
        </div>
    </div>
</div>